import { useTheme } from '@mui/material';

export default function TranscriptHandoffRightIcon() {
  const theme = useTheme();
  return (
    <svg width='123' height='1' viewBox='0 0 123 1' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='122.504' height='1' fill='url(#paint0_linear_14_2431)' />
      <defs>
        <linearGradient id='paint0_linear_14_2431' x1='122.504' y1='0.5' x2='0' y2='0.5' gradientUnits='userSpaceOnUse'>
          <stop stop-opacity='0' />
          <stop offset='1' stop-color={theme.palette.primary.main} stop-opacity='0.5' />
        </linearGradient>
      </defs>
    </svg>
  );
}
